import { useState, useEffect } from 'react';

import * as yup from 'yup';

export const useValidName = (initialValue: string | null) => {
  const [name, setName] = useState(initialValue);
  const [nameIsValid, setNameIsValid] = useState('');

  useEffect(() => {
    const nameSchema = yup.object().shape({
      name: yup
        .string()
        .min(1)
        .required()
        .matches(/^[aA-zZ\s]+$/, 'Only alphabets are allowed'),
    });

    if (name !== null) {
      if (name.length === 0) {
        setNameIsValid('The name is required');
        return;
      }
    } else {
      setNameIsValid('');
      return;
    }

    const isValid = nameSchema.isValidSync({ name });
    if (!isValid) {
      setNameIsValid('Only alphabets are allowed');
      return;
    }

    setNameIsValid('');
  }, [name]);

  return { name, setName, nameIsValid };
};
